<template>
  <div>
    <nav class="c-nav-menu">
      <button :class="`c-nav-menu__button ${activeClass}`" @click="$emit('toggleNav')">
        <div class="c-nav-menu__button-box">
          <div class="c-nav-menu__button-inner"></div>
        </div>
        <span class="c-nav-menu__button-text">Menu</span>
      </button>
      <transition name="slide">
        <div class="c-nav-menu__items-wrapper" v-if="isOpen">
          <div class="c-nav-menu__items">
            <div class="c-nav-menu__items-scroll">
              <a class="c-nav-menu__logo logo" href="//litera.com/" rel="nofollow" alt="Browse back to litera.com" target="_self">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 288 21.2">
                  <path d="M36.7 4.8c0-.2.2-.4.4-.4h2.1c.2 0 .4.2.4.4v13h5.9c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4H37c-.3 0-.4-.2-.4-.4l.1-15.3zm11.7 0c0-.2.2-.4.4-.4H51c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4h-2.2c-.2 0-.4-.2-.4-.4V4.8zm9.5 2.3h-3.6c-.3 0-.4-.2-.4-.4V4.8c0-.2.2-.4.4-.4h10.2c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-3.6v13c0 .2-.2.4-.4.4h-2.2c-.2 0-.4-.2-.4-.4v-13zm9.4-2.3c0-.2.2-.4.4-.4h9.5c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-6.9V11H76c.2 0 .4.2.4.4v1.9c0 .3-.2.4-.4.4h-5.7v4.1h6.9c.3 0 .4.2.4.4v1.9c0 .2-.2.4-.4.4h-9.5c-.3 0-.4-.2-.4-.4V4.8zm13.7 0c0-.2.2-.4.4-.4H88c2.8 0 5.1 2.2 5.1 5 0 2.1-1.4 3.9-3.4 4.7l3.2 5.9c.2.3 0 .7-.4.7h-2.4c-.2 0-.3-.1-.4-.2l-3.1-6.2H84v5.9c0 .2-.2.4-.4.4h-2.1c-.3 0-.4-.2-.4-.4L81 4.8zm6.8 7c1.2 0 2.3-1.1 2.3-2.4 0-1.2-1.1-2.3-2.3-2.3H84v4.6h3.8v.1zm6.6 8.2l7.2-15.6c.1-.1.2-.3.4-.3h.2c.2 0 .3.1.4.3l7.2 15.6c.1.3 0 .6-.4.6h-2c-.3 0-.5-.1-.7-.5l-1.1-2.5h-7l-1.1 2.5c-.1.2-.3.5-.7.5h-2c-.4 0-.6-.3-.4-.6zm10-4.9l-2.3-5.1h-.1l-2.3 5.1h4.7zm14.5-10.6c0-.2.2-.3.4-.3h.4c.1 0 .3.1.4.3l4.9 11.9h.1l4.8-11.9c0-.1.2-.3.4-.3h.4c.2 0 .4.2.4.3l2.9 15.6c.1.3-.1.5-.4.5H132c-.2 0-.4-.2-.4-.3l-1.7-10.4h-.1l-4.2 10.7c0 .1-.2.3-.4.3h-.4c-.2 0-.3-.1-.4-.3l-4.2-10.7h-.1l-1.7 10.4c0 .2-.2.3-.4.3h-1.5c-.3 0-.5-.2-.4-.5l2.8-15.6zm18.5.3c0-.2.2-.4.4-.4h1.5c.2 0 .4.2.4.4v15.4c0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4V4.8zm14.1-.7c2.3 0 4 .8 5.6 2.2.2.2.2.5 0 .7l-1 1c-.2.2-.4.2-.6 0-1.1-1-2.6-1.6-4-1.6-3.3 0-5.8 2.8-5.8 6s2.5 6 5.9 6c1.7 0 2.9-.7 4-1.5.2-.2.4-.1.6 0l1.1 1c.2.2.1.5 0 .6-1.6 1.5-3.6 2.3-5.7 2.3-4.6 0-8.4-3.7-8.4-8.3s3.6-8.4 8.3-8.4zm9 .7c0-.2.2-.4.4-.4h6.3c2.8 0 5.1 2.2 5.1 5 0 2.1-1.4 3.9-3.4 4.7L172 20c.2.3 0 .7-.4.7h-1.8c-.2 0-.3-.1-.4-.2l-3.1-6.2h-3.5v5.9c0 .2-.2.4-.4.4h-1.5c-.3 0-.4-.2-.4-.4V4.8zm6.6 7.5c1.5 0 2.8-1.3 2.8-2.9 0-1.5-1.3-2.8-2.8-2.8H163v5.6h4.1v.1zm16-8.2c4.7 0 8.4 3.7 8.4 8.4s-3.7 8.3-8.4 8.3c-4.6 0-8.3-3.7-8.3-8.3s3.6-8.4 8.3-8.4zm0 14.4c3.3 0 6-2.7 6-6s-2.7-6.1-6-6.1-6 2.8-6 6.1 2.7 6 6 6zm10.6-.2c.2-.3.4-.7.6-1 .2-.3.5-.4.8-.2.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.2-.2-.4-.3-.2-.7zm16.8-5.5L205 5c-.2-.3 0-.7.4-.7h1.7c.2 0 .3.1.4.2l4.2 5.9 4.2-5.9c.1-.1.2-.2.4-.2h1.7c.4 0 .6.4.4.7l-5.5 7.7v7.4c0 .2-.2.4-.4.4H211c-.3 0-.4-.2-.4-.4l-.1-7.3zm9.1 5.5c.2-.3.4-.7.6-1 .2-.3.5-.4.8-.2.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.3-.2-.5-.3-.2-.7zm15.7-11.8h-3.8c-.3 0-.4-.2-.4-.4V4.8c0-.2.2-.4.4-.4h10c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-3.8v13.6c0 .2-.2.4-.4.4h-1.5c-.2 0-.4-.2-.4-.4V6.5h-.1zm9.2-1.7c0-.2.2-.4.4-.4h9.3c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-7.3v4.7h6.2c.2 0 .4.2.4.4V13c0 .3-.2.4-.4.4h-6.2v5h7.3c.3 0 .4.2.4.4v1.3c0 .2-.2.4-.4.4h-9.3c-.3 0-.4-.2-.4-.4V4.8zm15.4-.3c0-.2.2-.3.4-.3h.4c.1 0 .3.1.4.3l4.9 11.9h.1l4.8-11.9c0-.1.2-.3.4-.3h.4c.2 0 .4.2.4.3l2.9 15.6c.1.3-.1.5-.4.5H273c-.2 0-.4-.2-.4-.3l-1.7-10.4h-.1l-4.2 10.7c0 .1-.2.3-.4.3h-.4c-.2 0-.3-.1-.4-.3l-4.2-10.7h-.1l-1.7 10.4c0 .2-.2.3-.4.3h-1.5c-.3 0-.5-.2-.4-.5l2.8-15.6zm17.4 13.8c.2-.3.4-.7.6-1s.5-.4.8-.2c.1.1 1.9 1.6 3.7 1.6 1.6 0 2.6-1 2.6-2.2 0-1.4-1.2-2.3-3.5-3.2-2.4-1-4.2-2.2-4.2-4.9 0-1.8 1.4-4.3 5.1-4.3 2.3 0 4.1 1.2 4.3 1.4.2.1.4.4.1.8l-.6.9c-.2.3-.5.4-.8.2-.2-.1-1.8-1.2-3.1-1.2-2 0-2.6 1.2-2.6 2.1 0 1.3 1 2.1 3 2.9 2.7 1.1 5 2.4 5 5.2 0 2.4-2.2 4.4-5.2 4.4-2.8 0-4.6-1.5-5-1.8-.2-.2-.4-.3-.2-.7z"/><path fill="#f26924" d="M17.4.3c-1.3 0-1.9 1.1-1.3 2.3l8.4 18h6c1.3 0 1.9-1.1 1.3-2.3L23.4.3h-6z"/><path fill="#fdb714" d="M8.2 6.7l6.5 13.9h6c1.3 0 1.9-1.1 1.3-2.3l-6.6-14h-6c-1.3 0-1.8 1.1-1.2 2.4z"/><path fill="#00a176" d="M.6 11.9l4.1 8.7h6c1.3 0 1.9-1.1 1.3-2.3L7.9 9.6h-6c-1.3 0-1.9 1-1.3 2.3z"/>
                </svg>
              </a>
              <h3 class="c-nav-menu__item-contents">Contents</h3>
              <nav-menu-category category="Leadership" :posts="posts" />
              <nav-menu-category category="Legal Market" :posts="posts" />
              <nav-menu-category category="Legal Tech" :posts="posts" />
              <nav-menu-category category="Management" :posts="posts" />
            </div>
            <router-link v-if="['post'].indexOf($route.name) > -1" class="c-home-button" :to="{ name: 'homepage' }">
              <svg class="c-home-button__icon" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 32 32"><path d="M0 16c0 0.3 0.1 0.5 0.3 0.7l9.9 10c0.4 0.4 1 0.4 1.4 0 0.4-0.4 0.4-1 0-1.4L3.4 17H31c0.6 0 1-0.5 1-1s-0.4-1-1-1H3.4l8.2-8.3c0.4-0.4 0.4-1 0-1.4 -0.4-0.4-1-0.4-1.4 0l-9.9 10C0.1 15.5 0 15.7 0 16z" fill="#121313"/></svg>
              <span class="c-home-button__text">Back to Cover</span>
             </router-link>
          </div>
        </div>
      </transition>
    </nav>
    <transition name="fadeIn">
      <div class="nav-underlay" v-if="isOpen" @click="$emit('toggleNav')"></div>
    </transition>
  </div>
</template>

<script>
import NavMenuCategory from '@/components/NavMenuCategory'

export default {
  name: 'nav-menu',
  components: {
    NavMenuCategory
  },
  props: {
    posts: Array,
    isOpen: Boolean
  },
  methods: {},
  computed: {
    menuText () {
      return this.isOpen ? 'Close ✕' : 'Menu ♢'
    },
    activeClass () {
      return this.isOpen ? 'is-active' : ''
    }
  }
}
</script>

<style lang="scss" scoped>
.c-home-button {
  border-bottom: 1px solid #eee;
  box-sizing: border-box;
  color: #1A1919;
  font-family: $font-heading;
  font-size: 11px;
  font-weight: 700;
  top: 0;
  left: 0;
  padding: .8rem 1.5rem .8rem 3rem;
  position: absolute;
  text-align: left;
  text-transform: uppercase;
  width: 100%;
  background: #fff;

  &:hover {
    background-color: rgba($purple, 0.1);

    .c-home-button__icon {
      transform: translateX(-5px);
      transition: transform .2s ease-in-out;
    }

  }
}

.c-home-button__icon {
  position: absolute;
  left: 1.5rem;
}

.c-nav-menu__items-wrapper {
  position: fixed;
  left: 0;
  bottom: 0;

  backface-visibility: hidden;
  will-change: transform, opacity;
  z-index: z('nav-menu-items');

  @if ($masthead-enabled == true) {
    top: $masthead-height;
    height: calc(100% - #{$masthead-height});
  } @else {
    top: 0;
    height: 100%;
  }

  @media (min-width: $breakpoint-md) {
    width: $nav-width;
  }

  @media (min-width: $breakpoint-lg) {
    left: $nav-button-width;
  }
}

.c-nav-menu__items-scroll {
  width: 100%;
  height: 100%;
  padding-left: .5rem;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}

.c-nav-menu__items {
  padding: 2rem 1rem;
  background-color: #fff;
  box-shadow: 0 0 10px rgba(0,0,0,0.1);
  height: 100%;
  will-change: transform, opacity;

  @media (min-width: $breakpoint-lg) {
    padding: 2rem;
  }
}

.c-nav-menu__logo {
  margin-top: 3rem;
  display: block;
}

.c-nav-menu__logo svg {    
  width: 96%;
}

.c-nav-menu__item-contents {
  border-bottom: 1px solid;
  display: inline-block;
  font-style: italic;
  font-weight: 300;
  margin-top: 2rem;
}

// Aside Nav Bar
.c-nav-menu__button {
  background-color: #fff;
  border: 1px solid #eee;
  bottom: 1rem;
  cursor: pointer;
  height: $nav-button-width;
  padding: 0;
  position: fixed;
  right: 18px;
  transition-property: opacity, filter;
  transition-duration: $hamburger-hover-transition-duration;
  transition-timing-function: $hamburger-hover-transition-timing-function;
  width: $nav-button-width;
  z-index: z('nav-menu-button');
  -webkit-backface-visibility: hidden;

  @media (min-width: $breakpoint-lg) {
    align-items: center;
    appearance: none;
    border: none;
    border-radius: 0;
    bottom: auto;
    box-shadow: 0 0 10px rgba(0,0,0,.1);
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    left: 0;
    right: auto;
    padding: $hamburger-padding-y $hamburger-padding-x;
    position: fixed;
    text-transform: uppercase;
    user-select: none;
    width: $nav-button-width;
    white-space: nowrap;

    @if ($masthead-enabled == true) {
      top: $masthead-height;
      height: (100vh - #{$masthead-height});
    } @else {
      top: 0;
      height: 100vh;
    }
  }

  &:focus {
    outline: none;
  }

  &:hover {
    @if $hamburger-hover-use-filter == true {
      filter: $hamburger-hover-filter;
    }
    @else {
      opacity: $hamburger-hover-opacity;
    }

    .c-nav-menu__button-inner,
    .c-nav-menu__button-inner:before,
    .c-nav-menu__button-inner:after {
      -webkit-backface-visibility: hidden;
      transform: scale(1.1) translateZ(0);
      background-color: darken($purple, 20%);
    }

  }
}

.c-nav-menu__button-box {
  width: $hamburger-layer-width;
  height: $hamburger-layer-height * 3 + $hamburger-layer-spacing * 2;
  display: inline-block;
  position: relative;
}

.c-nav-menu__button-inner {
  display: block;
  margin-top: $hamburger-layer-height / -2;
  top: auto;
  bottom: 0;
  transition-duration: 0.13s;
  transition-delay: 0.13s;
  transition-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19);

  &,
  &::before,
  &::after {
    width: $hamburger-layer-width;
    height: $hamburger-layer-height;
    background-color: $hamburger-layer-color;
    border-radius: $hamburger-layer-border-radius;
    position: absolute;
    transition-property: transform;
    transition-duration: 0.15s;
    transition-timing-function: ease;
  }

  &::before,
  &::after {
    content: "";
    display: block;
  }

  &::before {
    top: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
                transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }

  &::after {
    bottom: ($hamburger-layer-spacing + $hamburger-layer-height) * -1;
    top: ($hamburger-layer-spacing * 2 + $hamburger-layer-height * 2) * -1;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1),
                opacity 0.1s linear;
  }
}

.c-nav-menu__button.is-active .c-nav-menu__button-inner {
  transform: translate3d(0, ($hamburger-layer-spacing + $hamburger-layer-height) * -1, 0) rotate(-45deg) ; 
  transition-delay: 0.22s;
  transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);

  &::after {
    top: 0;
    opacity: 0;
    transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
                opacity 0.1s 0.22s linear;
  }

  &::before {
    top: 0;
    transform: rotate(-90deg);
    transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333),
                transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1);
  }
}

.c-nav-menu__button-text {
  display: none;
  color: $legal-tech;
  font-family: $font-heading;
  font-size: 1rem;
  top: calc(50% + 36px);
  margin-left: 0.15rem;
  position: absolute;
  transform: rotate(-90deg) translateZ(0) scale(1.0, 1.0);
  -webkit-backface-visibility: hidden;
  @media (min-width: $breakpoint-lg) {
    display: inline-block;
  }
}

.nav-underlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: #000;
  opacity: .4;
  z-index: z('nav-underlay');
}

.fadeIn-enter-active {
  transition: opacity .5s
}

.fadeIn-enter,
.fadeIn-leave-to {
  opacity: 0
}

.slide-enter-active {
  animation: slideInLeft .4s;
}

.slide-leave-active  {
  animation: slideInLeft .2s reverse;
}

@keyframes slideInLeft {
  from {
    transform: translate3d(-100%, 0, 0);
    visibility: visible;
  }

  to {
    transform: translate3d(0, 0, 0);
  }
}
</style>



// WEBPACK FOOTER //
// NavMenu.vue?6e315bfa